module.exports = __webpack_public_path__ + "static/sf-ui-semibold-fbefe25c170504d8722d4d32bfeffaae.woff2";